<script setup lang="ts">
import {computed, inject} from 'vue'
import {useLocalization} from '@hantera/portal-app'
import SessionList from '../Shared/SessionList.vue'
import type {useClientStore} from '@/stores/iam/client-store'

const t = useLocalization('iam.clients')
const store = inject<ReturnType<typeof useClientStore>>('clientStore')!

const sessions = computed(() => store.sessions)
const canWrite = computed(() => store.canWrite)

async function handleRevokeSession(sessionId: string) {
  if (!store.client) return

  try {
    await store.iamService.revokeClientSession(store.client.id, sessionId)
    await store.refresh()

    store.processes.createProcess({
      description: t('sessions.revoked'),
    }).complete()
  } catch (error) {
    console.error('Failed to revoke session:', error)
    store.processes.error({ message: 'Failed to revoke session' })
  }
}
</script>

<template>
  <div class="sessions-tab">
    <SessionList 
      :sessions="sessions"
      :can-revoke="canWrite"
      @revoke="handleRevokeSession"
    />
  </div>
</template>

<style scoped>
.sessions-tab {
  padding: 1.5rem;
}
</style>
